(function () {
  // Product gallery thumbnails (keyboard support like the Replit app)
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-main]');
    var buttons = Array.prototype.slice.call(gal.querySelectorAll('.thumbs button'));
    if (!main || !buttons.length) return;
    buttons.forEach(function (b, i) {
      b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + buttons.length);
      b.addEventListener('click', function () { show(i); });
    });
    function show(i) {
      var b = buttons[i];
      main.src = b.getAttribute('data-src');
      main.alt = b.querySelector('img').alt;
      main.classList.toggle('store-photo', !b.hasAttribute('data-styled'));
      buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    }
    gal.querySelector('.thumbs').addEventListener('keydown', function (e) {
      var steps = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      var from = buttons.indexOf(document.activeElement);
      if (from < 0) return;
      var next = e.key === 'Home' ? 0 : e.key === 'End' ? buttons.length - 1 : (e.key in steps ? (from + steps[e.key] + buttons.length) % buttons.length : -1);
      if (next < 0) return;
      e.preventDefault(); show(next); buttons[next].focus();
    });
  });
  // Variant pills update price and buy buttons
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var price = document.querySelector('[data-price]');
    var buy = form.querySelector('[data-buy]');
    var add = form.querySelector('[data-add]');
    form.querySelectorAll('.vpill-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var ok = input.getAttribute('data-available') === 'true';
        if (price) price.textContent = input.getAttribute('data-price');
        [buy, add].forEach(function (btn) { if (!btn) return; btn.disabled = !ok; btn.setAttribute('aria-disabled', ok ? 'false' : 'true'); });
        if (buy) buy.textContent = ok ? 'Buy' : 'Sold out';
        var url = new URL(window.location.href); url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  });
})();
